// src/components/Services.js
import React from 'react';
import { Container, Typography } from '@mui/material';

const Services = () => {
  return (
    <Container>
      <Typography variant="h4" sx={{ mt: 4 }}>Our Courses</Typography>
      <Typography sx={{ mt: 2 }}>
     At SMC JAIN SCHOOL-SHAHAPUR , we offer specialized courses,summer vacation with regular classes
      </Typography>
    </Container>
  );
};

export default Services;
